import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const CustomerPages = {
  list: 'ListCustomer',
  add: 'AddCustomer',
  edit: 'EditCustomer',
}

const title = t('navigation.customers')
const path = '/customers'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: CustomerPages.add,
  component: () => import('@/pages/mainPageWithRoute/customer/AddCustomerPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: CustomerPages.edit,
  component: () => import('@/pages/mainPageWithRoute/customer/EditCustomerPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: CustomerPages.list,
  component: () => import('@/pages/mainPageWithRoute/customer/ListCustomerPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Customers: RouteRecordRaw = {
  path,
  name: t('navigation.customers'),
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
